module.exports = __webpack_public_path__ + "img/ChillenAnDerBib.bb633e88.svg";